import { useRef } from "react";
import { Upload, Trash2, Download, Paperclip } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCarbonSurveysStore } from "../hooks";
import { useTran } from "@/hooks";
import { observer } from "mobx-react-lite";
import { formatSize } from "@/features/esg/utils/evidence-utils";

const EvidenceUpload = observer(({ proofs, mode, scope, isEdit }) => {
  const { t } = useTran();
  const { isUploading, uploadFile, downloadFile, removeFile } =
    useCarbonSurveysStore();
  const inputRef = useRef(null);

  // const proofs =  [];

  const handleSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";

    const proof = await uploadFile(file, scope, mode);
    // updateEntry(code, entryIndex, "proofs", [...proofs, proof]);
  };

  const handleDelete = async (fileId) => {
    await removeFile(fileId, mode, scope, isEdit);
  };

  return (
    <div className="pt-2 border-t border-border">
      {proofs.length === 0 ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-7 text-xs text-muted-foreground"
          onClick={() => inputRef.current?.click()}
          disabled={isUploading}
        >
          <Paperclip size={14} />
          {isUploading ? t("Uploading...") : t("Attach evidence")}
        </Button>
      ) : (
        <>
          <div className="flex items-center justify-between">
            <p className="text-xs font-medium text-muted-foreground">
              {t("Evidence")} ({proofs.length})
            </p>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="h-6 text-xs"
              onClick={() => inputRef.current?.click()}
              disabled={isUploading}
            >
              <Upload size={12} />
              {isUploading ? t("Uploading...") : t("Add")}
            </Button>
          </div>

          <div className="space-y-1 mt-1">
            {proofs.map((proof) => (
              <div
                key={proof.fileId}
                className="flex items-center gap-2 bg-muted rounded-md px-2 py-1"
              >
                <span className="text-sm truncate flex-1">{proof.name}</span>
                <span className="text-[10px] text-muted-foreground whitespace-nowrap">
                  {formatSize(proof.size)}
                </span>
                <div className="flex items-center gap-1">
                  <button
                    type="button"
                    className="text-muted-foreground hover:text-foreground transition-colors"
                    onClick={() => downloadFile(proof)}
                  >
                    <Download size={14} />
                  </button>
                  <button
                    type="button"
                    className="text-muted-foreground hover:text-destructive transition-colors"
                    onClick={() => handleDelete(proof.fileId)}
                    // disabled={disabled}
                  >
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      <input
        ref={inputRef}
        type="file"
        className="hidden"
        accept=".pdf,.csv,.xlsx,.xls,.png,.jpg,.jpeg"
        onChange={handleSelect}
      />
    </div>
  );
});

export default EvidenceUpload;
